import React, { useEffect, useState } from "react";
import "./NewsArticle.scss";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";
import { Seo } from "../../../../components/Seo";

const NewsArticle = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [index, setIndex] = useState(0);
  const langNavigate = useLangNavigate();
  useEffect(() => {
    setIndex(Number(id));
  }, [id]);
  const handleBack = () => {
    langNavigate("news/press");
  };
  const handleMove = (page: number) => {
    langNavigate(`news/press/${index + page}`);
  };
  const news = t("news", { returnObjects: true }) as { path: string; title: string; date: string; des: string }[];

  return (
    <>
      <Seo title={news[index].title} description={news[index].des.replace(/<[^>]*>/g, "").slice(0, 150)} path={`/news/press/${index}`} />
      <div id="news_article_wrap">
        <div className="news_header">
          <button onClick={handleBack}>
            <img src="/imgs/btn_back_arrow.png" alt="back button" />
          </button>
          <h1 className="title">{news[index].title}</h1>
          <div className="date">{news[index].date}</div>
        </div>
        <div className="article_wrap">{news[index].des}</div>
        <div className="n_wrap">
          {index === 0 ? null : (
            <div
              className="m_wrap pre_wrap"
              onClick={() => {
                handleMove(-1);
              }}
            >
              <div className="s pre">{t("newsEducation.newsRoom.pressRelease.pre")}</div>
              <div className="t pre_title">
                <span>{news[index - 1].title}</span>
              </div>
            </div>
          )}
          {index === news.length - 1 ? null : (
            <div
              className="m_wrap next_wrap"
              onClick={() => {
                handleMove(1);
              }}
            >
              <div className="s next">{t("newsEducation.newsRoom.pressRelease.next")}</div>
              <div className="t next_title">
                <span>{news[index + 1].title}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NewsArticle;
